import { createSelector } from '@ngrx/store';
import { OptionState } from '../../../../../models';
import { createFieldRelatedOptionsSelector } from '../create-field-related-options/create-field-related-options.selector';

// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
export const createFieldRelatedCheckedOptionsSelector = (filterInstanceId: string, fieldId: string) =>
  createSelector(createFieldRelatedOptionsSelector(filterInstanceId, fieldId), (fieldRelatedOptions: OptionState[]) => {
    return fieldRelatedOptions.filter((opt) => opt.isChecked);
  });
